<template>
  <div style="position: fixed;bottom: 20px;right: 20px;">
    <div v-for="(message, i) of messages" :key="i">
      <div class="messagePop" v-if="message.detail.show" :class="{ show: message.detail.show }">
        <div
          v-if="message.detail.icon && !message.detail.image"
          :style="{ 'background-color': $theme[message.detail.type] }"
          class="icon icon-shape mb-4 rounded-circle "
          style="margin: 0 14px 0 0 !important;height: 40px;width: 40px;"
        >
          <i :class="message.detail.icon" aria-hidden="true"></i>
        </div>
        <div
          v-if="message.detail.image"
          class="avatar"
          :style="{ 'background-image': `url(${message.detail.image})` }"
        ></div>
        <div
          class="message"
          :style="{ color: $theme[message.detail.type] }"
          v-html="message.detail.message"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "base-message",
  data() {
    return {
      show: false,
      icon: false,
      image: false,
      type: "",
      messages: [],
    };
  },
  created() {
    window.addEventListener(
      "message",
      (e) => {
        if (e.detail) {
          
          if (e.detail.icon.includes("http")) {
            e.detail.image = e.detail.icon;
          } 
          e.detail.show = true
          this.messages.push(e);
          setTimeout(() => {
            this.messages.splice(this.messages.length - 1, 1);
          }, 5000);
        }
      },
      false
    );
  },
  methods: {},
};
</script>
<style lang="scss">
.messagePop {
  display: flex;
  align-items: center;
  bottom: -200px;
  right: 20px;
  background: white;
  padding: 1rem 2rem 1rem 1rem;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px;
  opacity: 0;
  margin-bottom: 0.5rem;
  transition: all 0.8s ease-in-out;

  &.show {
    bottom: 20px;
    opacity: 1;
  }
  .avatar {
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: 1rem;
  }
}
</style>
